<template>
  <div
    class="privacy-policy"
    :style="{
      backgroundColor: background,
      color: text_color
    }"
    v-if="is_eur_ip && !accept_privacy_policy && show_privacy_policy && !hideen_privacy_policy"
  >
    <div class="privacy-policy__text">
      <div class="privacy-policy__text-title">{{ title }}</div>
      <span>
        {{ description }}
        <a :href="privacy_policy_link" style="color:#3461ff"> {{ privacy_policy_title }}</a>
      </span>
    </div>

    <div class="privacy-policy__botton">
      <button
        class="privacy-policy__botton-rejection"
        :style="{
          border: `1px ${button_color} solid`,
          color: button_color
        }"
        @click="rejection()"
      >
        {{ rejection_button }}
      </button>
      <button
        class="privacy-policy__botton-accept"
        :style="{
          backgroundColor: button_color,
          color: background,
          border: ` 1px ${button_color} solid`
        }"
        @click="accept()"
      >
        {{ accept_button }}
      </button>
    </div>
  </div>
</template>

<script>
// import API from '@/js/API'
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      background: null,
      text_color: null,
      button_color: null,
      title: null,
      description: null,
      accept_button: null,
      rejection_button: null,
      privacy_policy_title: null,
      privacy_policy_link: null,
      is_eur_ip: false,
      accept_privacy_policy: true,
      show_privacy_policy: true,
      hideen_privacy_policy: true
    }
  },
  methods: {
    async fetchPrivacy() {
      // 是否接受隐私政策
      this.accept_privacy_policy = localStorage.getItem('accept_privacy_policy')
      // 隐藏隐私政策
      this.hideen_privacy_policy = sessionStorage.getItem('hideen_privacy_policy')
      if (this.accept_privacy_policy || this.hideen_privacy_policy) return
      const res = await this.$axios.get(API.privacy_policy)
      const {
        background,
        text_color,
        button_color,
        title,
        description,
        accept_button,
        rejection_button,
        privacy_policy_title,
        privacy_policy_link,
        is_eur_ip
      } = res.data

      this.background = background || '#FFFFFF'
      this.text_color = text_color || '#000000'
      this.button_color = button_color || '00000'
      this.title = title
      this.description =
        description || 'This website uses cookies to ensure you get the best experience on our website.'
      this.accept_button = accept_button || 'ACCEPT'
      this.rejection_button = rejection_button || 'DECLINE'
      this.privacy_policy_title = privacy_policy_title || 'Privacy Policy'
      this.privacy_policy_link = privacy_policy_link
      this.is_eur_ip = is_eur_ip || false
    },
    rejection() {
      this.show_privacy_policy = false
      // 隐藏隐私政策
      sessionStorage.setItem('hideen_privacy_policy', true)
    },
    accept() {
      this.show_privacy_policy = false
      localStorage.setItem('accept_privacy_policy', true)
    }
  },
  beforeMount() {
    this.fetchPrivacy()
  }
}
</script>

<style lang="scss">
.privacy-policy {
  position: fixed !important;
  bottom: 0;
  left: 0;
  width: 100%;
  // background: #DEE0E7;
  z-index: 99;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 3px 12px 6px rgba(12, 72, 128, 0.06);
  &__text {
    &-title {
      font-size: 16px;
      font-weight: 700;
      padding-bottom: 8px;
    }
  }
  &__botton {
    white-space: nowrap;
    &-accept {
      padding: 8px;
      min-width: 100px;
      border-radius: 4px;
    }
    &-rejection {
      padding: 8px;
      min-width: 100px;
      border-radius: 4px;
      margin-right: 5px;
    }
  }
}
@media screen and (max-width: 767px) {
  .privacy-policy {
    flex-direction: column;
    &__botton {
      width: 100%;
      display: flex;
      justify-content: space-around;
      padding-top: 20px;
      &-rejection {
        width: 50%;
        margin-right: 5px;
      }
      &-accept {
        width: 50%;
        margin-left: 5px;
      }
    }
  }
}
</style>
